import Vue from 'vue';
import firebase from '../../firebase';
import moment from "moment";

function initialDonationState() {
    return {
        key: null,
        updateddate: null,
        createddate: null,
        formWizardCurrentStep: null,
        url: null,
        method: null,
        isLoading: false,
        // Step1        
        isGift: false,
        packagecode: null,
        type: null, // Single/Regular selected
        campaignid: null,
        fundid: null,
        amount: null,
        dollarhandle: null,
        email: null,
        optin: true,
        // Step2    
        isBehalfBusiness: false,
        bussiness: {
            name: null
        },
        title: null,
        firstname: null,
        lastname: null,
        phone: null,
        billing: {
            unitnumber: null,
            streetno: null,
            streetname: null,
            postcode: null,
            state: '',
            suburb: null,
            country: 'Australia'
        },
        isSameAddress: true,
        gift: {
            title: null,
            firstname: null,
            lastname: null,
            unitnumber: null,
            streetno: null,
            streetname: null,
            postcode: null,
            state: null,
            suburb: null,
            country: null
        },
        wildcard: {
            dear: null,
            message: null,
            email: null,
            scheduledate: null,
            img: null,
            pdf: null
        },
        payementType: 'wwf_purchasetokenise',
        transactionid: null,
        isProcessing: false,
        step2Data: {
            addressSelected: null,
            addressgiftSelected: null,
            showAddressSuggestions: true,
            showAddressGiftSuggestions: true,
            showFullAddress: false,
            showFullAddressGifts: false,
        }
    }
}

const state = {
    donation: initialDonationState()
}

const getters = {
    donation: state => state.donation,
    step2Data: state => state.donation.step2Data
}

const mutations = {
    updateDonation: function (state, { field, value }) {
        console.log("updatedonation", field, value);
        if (value != undefined) {
            Object.assign(state.donation, {
                [field]: value
            });
        }
    },
    updateDonationBussiness: function (state, { field, value }) {
        console.log("updateDonationBussiness", field, value);
        if (value != undefined) {
            Object.assign(state.donation.bussiness, {
                [field]: value
            });
        }
    },
    updateDonationBilling: function (state, { field, value }) {
        console.log("updateDonationBilling", field, value);
        if (value != undefined) {
            Object.assign(state.donation.billing, {
                [field]: value
            });
        }
    },
    updateDonationGift: function (state, { field, value }) {
        console.log("updateDonationGift", field, value);
        if (value != undefined) {
            Object.assign(state.donation.gift, {
                [field]: value
            });
        }
    },
    updateDonationWildcard: function (state, { field, value }) {
        console.log("updateDonationWildcard", field, value);
        if (value != undefined) {
            Object.assign(state.donation.wildcard, {
                [field]: value
            });
        }
    },
    updateStep2Data: function (state, { field, value }) {
        console.log("updateStep2Data", field, value);
        if (value != undefined) {
            Object.assign(state.donation.step2Data, {
                [field]: value
            });
        }
    },
    resetDonation: function () {
        console.log("resetDonation mutation", state);
        const s = initialDonationState()
        Object.keys(s).forEach(key => {
            state.donation[key] = s[key]
        })
    },
    setTransactionId(state, id) {
        console.log('donate - setTransactionId - ', id);
        state.donation = { ...state.donation, transactionid: id };
    }
}

const actions = {
    saveDonationStep1: function ({ dispatch, state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            console.log('saveDonationStep1 State donation', state.donation)
            var date = new Date();

            // queryParams.fundid is the fundid set by query params. Always use this one if available
            const donation = {
                isGift: state.donation.isGift,
                packagecode: state.donation.packagecode,
                type: state.donation.type, // Single/Regular selected
                amount: state.donation.amount,
                dollarhandle: state.donation.dollarhandle,
                email: state.donation.email,
                optin: state.donation.optin,
                appealid: rootState.product.product.appealcodesetting.appealid,
                campaignid: state.donation.campaignid,
                fundid: rootState.product.queryParams.fundid ? rootState.product.queryParams.fundid : state.donation.fundid,
                producttype: rootState.product.product.producttype,
                productname: rootState.product.product.productname,
                productid: rootState.product.product.id,
                certificateurl: (rootState.product.product.certificateurl) ? rootState.product.product.certificateurl : null,
                source: rootState.product.product.source,
                formWizardCurrentStep: state.donation.formWizardCurrentStep
            }

            console.log('saveDonationStep1 Donation', donation)

            // if donation already exist
            if (state.donation.key) {
                console.log('Save donation with key', state.donation.key);

                donation.updateddate = date.toISOString();
                firebase.database.ref("pending-donations").child(state.donation.key)
                    .update(donation, function (error) {
                        if (error) {
                            console.log('Error has occured during saving step1 set process', error)
                            reject(error);
                        }
                        else {
                            console.log('saveDonation Step 1 set success')
                            resolve();
                        }
                    }).then(function (result) {
                        console.log("saveDonation Step 1 set:", result);
                    })
            }
            else {
                console.log('Save donation without key', state.donation.key);
                donation.createddate = date.toISOString();
                donation.updateddate = donation.createddate;

                // Request a key before adding into the database so we can save the key directlty
                const newRef = firebase.database.ref("pending-donations").push();
                donation.token = newRef.key;
                newRef.set(donation, (err) => {
                    if (err) {
                        console.log('Error has occured during saving step1 push process', err)
                        reject(err);
                    }
                    else {
                        console.log('saveDonation Step 1 push success')
                    }
                }).then(() => {
                    commit("updateDonation", { field: 'key', value: newRef.key });
                    resolve();
                });
            }
        })
    },
    saveDonationStep2: function ({ dispatch, state, commit }) {
        return new Promise((resolve, reject) => {
            console.log('saveDonationStep2 State donation', state.donation)
            console.log('saveDonationStep2 State product', state.product)
            var date = new Date()

            const donation = {
                isGift: state.donation.isGift,
                type: state.donation.type, // Single/Regular selected
                bussiness: state.donation.isBehalfBusiness ? {
                    name: state.donation.bussiness.name
                } : null,
                title: state.donation.title,
                firstname: state.donation.firstname,
                lastname: state.donation.lastname,
                phone: state.donation.phone,
                billing: {
                    unitnumber: state.donation.billing.unitnumber,
                    streetno: state.donation.billing.streetno,
                    streetname: state.donation.billing.streetname,
                    postcode: state.donation.billing.postcode,
                    state: state.donation.billing.state,
                    suburb: state.donation.billing.suburb,
                    country: state.donation.billing.country
                },
                isSameAddress: state.donation.isSameAddress,
                gift: state.donation.isGift ? {
                    title: state.donation.gift.title,
                    firstname: state.donation.gift.firstname,
                    lastname: state.donation.gift.lastname,
                    unitnumber: !state.donation.isSameAddress ? state.donation.gift.unitnumber : null,
                    streetno: !state.donation.isSameAddress ? state.donation.gift.streetno : null,
                    streetname: !state.donation.isSameAddress ? state.donation.gift.streetname : null,
                    postcode: !state.donation.isSameAddress ? state.donation.gift.postcode : null,
                    state: !state.donation.isSameAddress ? state.donation.gift.state : null,
                    suburb: !state.donation.isSameAddress ? state.donation.gift.suburb : null,
                    country: !state.donation.isSameAddress ? state.donation.gift.country : null
                } : null,
                wildcard: state.donation.wildcard
                    ? {
                        dear: state.donation.wildcard.dear,
                        message: state.donation.wildcard.message,
                        email: state.donation.wildcard.email,
                        scheduledate: state.donation.wildcard.scheduledate ? moment(state.donation.wildcard.scheduledate).format('YYYY-MM-DD') : null,
                        img: state.donation.wildcard.img,
                        pdf: state.donation.wildcard.pdf
                    }
                    : null,
                payementType: state.donation.payementType,
                formWizardCurrentStep: state.donation.formWizardCurrentStep
            }

            console.log('saveDonationStep2 Donation', donation)

            donation.updateddate = date.toISOString();
            firebase.database.ref("pending-donations").child(state.donation.key)
                .update(donation, function (error) {
                    if (error) {
                        console.log('Error has occured during saving step2 set process', error)
                        reject(error);
                    }
                    else {
                        console.log('saveDonation Step 2 set success')
                        resolve();
                    }
                }).then(function (result) {
                    console.log("saveDonation Step 2 set:", result);
                })
        })
    },
    paymentCreditCard: function ({ dispatch, state, commit, rootState }, data) {
        state.donation.isLoading = true;
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/' + wwfconfigs.PAYMENTCREDITCARD, {
                token: data.token,
                cardHolderName: data.cardHolderName,
                uid: state.donation.key
            }).then(response => {
                console.log("payment", response);
                state.donation.isLoading = false;
                resolve(response);
            }, error => {
                console.error("payment", error);
                //Todo reset id firebase
                state.donation.isLoading = false;
                reject(error);
            });
        })
    },
    paymentDirectDebit: function ({ dispatch, state, commit, rootState }, data) {
        state.donation.isLoading = true;
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/' + wwfconfigs.PAYMENTDIRECTDEBIT, {
                accno: data.accno,
                accrouting: data.accrouting,
                acctitle: data.acctitle,
                uid: state.donation.key
            }).then(response => {
                console.log("payment", response);
                state.donation.isLoading = false;
                resolve(response);
            }, error => {
                console.error("payment", error);
                //Todo reset id firebase
                state.donation.isLoading = false;
                reject(error);
            });
        })
    },
    checkoutPaypal: function ({ dispatch, state, commit, rootState }, data) {
        state.donation.isLoading = true;
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/' + wwfconfigs.PAYPALCHECKOUT, {
                uid: state.donation.key
            }).then(response => {
                console.log("checkoutPaypal", response);
                state.donation.isLoading = false;
                resolve(response.body);
            }, error => {
                console.error("checkoutPaypal", error);
                //Todo reset id firebase
                state.donation.isLoading = false;
                reject(error);
            });
        })
    },
    paymentPaypal: function ({ dispatch, state, commit, rootState }, data) {
        state.donation.isProcessing = true
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/' + wwfconfigs.PAYMENTPAYPAL, {
                paymentid: data.paymentid,
                payerid: data.payerid
            }).then(response => {
                console.log("paymentPaypal", response);
                state.donation.isProcessing = false
                resolve(response.body);
            }, error => {
                console.error("paymentPaypal", error);
                //Todo reset id firebase
                state.donation.isProcessing = false
                reject(error);
            });
        })
    },
    retryDonation: async function ({ commit, dispatch }) {
        // Set the value to empty because the previous donation is failed
        commit("updateDonation", { field: "key", value: '' });
        await dispatch("saveDonationStep1");
        return await dispatch("saveDonationStep2");
    },
    resetDonation: function ({ commit }) {
        commit("resetDonation");
    },
    getCustomCheckoutFeatureSwitch({ commit }, productId) {
        return new Promise((resolve, reject) => {
            Vue.http.get(`${wwfconfigs.CLOUDFUNCTION}/getSetting?settingId=bambora-checkout`,).then(response => {
                const setting = response.body;
                const productSetting = setting.products[productId];
                const active = productSetting !== undefined && productSetting !== null ? productSetting : setting.default;
                resolve(active);
            }, error => {
                console.error("getCustomCheckoutFeatureSwitch", error);
                reject(error);
            });
        });
    },

    // OLD BAMBORA CHECKOUT
    checkout: function ({ dispatch, state, commit, rootState }) {
        console.log('checkout', state)
        commit("updateDonation", { field: 'method', value: '' });
        commit("updateDonation", { field: 'url', value: '' });
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/' + wwfconfigs.CHECKOUT, {
                // The method doesnt like the amount with. 
                amount: state.donation.amount.replace(',', ''),
                //amount: state.donation.amount
                paymentType: state.donation.payementType,
                email: state.donation.email,
                custRef: state.donation.key,
                productid: rootState.product.product.id,// ok
                productname: rootState.product.product.productname, // ok
                producttype: rootState.product.product.producttype, // Ok
                campaignid: rootState.product.product.appealcodesetting.campaignid, // ok
                fundid: rootState.product.product.appealcodesetting.fundid, //ok 
                appealid: rootState.product.product.appealcodesetting.appealid,//ok
                type: state.donation.type,
                source: rootState.product.product.source
            }).then(response => {
                console.log("checkout", response)
                commit("updateDonation", { field: 'method', value: response.body.method });
                commit("updateDonation", { field: 'url', value: response.body.url });
                resolve(response)
            }, error => {
                console.error("checkout", error)
                reject(error)
            });
        })
    },
}

export default {
    state,
    actions,
    getters,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/donate.js